import * as _ from 'lodash';
import mailCategoriesReducer from './MailCategoriesReducer';
import productSelectorReducer from './ProductSelectorReducer';
import { getAllSubClassCodes } from '../selectors/MailClassesSelectors';

const initialState = { categories: {} };

export default function rootReducer(state = initialState, action) {
  const { categories, ...rest } = state;
  const productSelectorState = productSelectorReducer(_.isEmpty(rest) ? undefined : rest, action);
  const newCategories = mailCategoriesReducer(
    categories, action,
    getAllSubClassCodes(productSelectorState),
  );

  return { ...productSelectorState, categories: newCategories };
}

